import { render, staticRenderFns } from "./ItemRontott7m.vue?vue&type=template&id=c62e4d1c&scoped=true&"
import script from "./ItemRontott7m.vue?vue&type=script&lang=js&"
export * from "./ItemRontott7m.vue?vue&type=script&lang=js&"
import style0 from "./ItemRontott7m.vue?vue&type=style&index=0&id=c62e4d1c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c62e4d1c",
  null
  
)

export default component.exports